/**
 * Mixpanel分析用定数のメインエントリーポイント
 *
 * 使用方法:
 * ```typescript
 * import { TrackedForms, EventName, Feature } from '@/constants/mixpanel'
 * ```
 *
 * 新しいフォーム設定を追加する場合は、適切なカテゴリファイルに追加してください：
 * - 共通機能（admin/user両方）: ./common.ts
 * - admin専用機能: ./admin.ts
 * - ユーザー専用機能: ./user.ts
 */

// カテゴリ別フォーム定義をインポート
import { AdminForms } from '@/constants/mixpanel/admin'
import { CommonForms } from '@/constants/mixpanel/common'
import { UserForms, UserButtons } from '@/constants/mixpanel/user'

// 型定義と定数をエクスポート
export * from '@/constants/mixpanel/types'
export * from '@/constants/mixpanel/constants'

/**
 * フォーム分析用の追跡設定
 * useTrackedFormで使用する各フォームの分析設定を定義
 *
 * @example
 * ```typescript
 * const form = useTrackedForm({
 *   formName: TrackedForms.Chat.CreateRoom,
 *   defaultValues: { ... }
 * })
 * ```
 */
export const TrackedForms = {
  // 後方互換性のため、既存の構造を維持
  ...CommonForms,
  ...AdminForms,
  ...UserForms,
} as const

/** TrackedForms定数の型 */
type TrackedFormsType = typeof TrackedForms

/** TrackedFormsの機能名の型 */
export type FeatureName = keyof TrackedFormsType

/** 指定した機能のフォーム名の型 */
export type FormName<F extends FeatureName> = keyof TrackedFormsType[F]

/**
 * ボタン分析用の追跡設定
 * useButtonAnalyticsで使用する各ボタンの分析設定を定義
 */
export const TrackedButtons = {
  ...UserButtons,
} as const
